module.exports = __webpack_public_path__ + "static/media/ilustracao-home-mobile.73c839d4.png";